import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.colors.background,
    display: 'flex',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'column',
    },
  },
  content: {
    height: theme.settings.size.mobile.mainPaperHeight,
    zIndex: 99,
    [theme.breakpoints.up('mobile')]: {
      height: theme.settings.size.desktop.mainPaperHeight,
      zIndex: 'unset',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/useStyles.js